import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
 //import DropZone from 'dropzone-vue';

Vue.component(FeatherIcon.name, FeatherIcon)
